import { render, staticRenderFns } from "./FaqSystem.vue?vue&type=template&id=cbac7738&scoped=true&"
import script from "./FaqSystem.vue?vue&type=script&lang=js&"
export * from "./FaqSystem.vue?vue&type=script&lang=js&"
import style0 from "./FaqSystem.vue?vue&type=style&index=0&id=cbac7738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbac7738",
  null
  
)

/* custom blocks */
import block0 from "@/public/locales/modules/faq/components/FaqSystem.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpublic%5Cmodules%5Cfaq%5Ccomponents%5CFaqSystem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports